import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { EnrollmentConstants } from '../constants/enrollment-constants';
import { MessageConstants } from '../constants/message-constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-enrollment-status',
  templateUrl: './enrollment-status.component.html',
  styleUrls: ['./enrollment-status.component.scss']
})
export class EnrollmentStatusComponent implements OnInit {

  @Output() saveEmitter: EventEmitter<any> = new EventEmitter<any>();

  account: any = {};
  selectedVehicles: Array<any> = [];
  vehicleList: Array<any> = [];
  vehicleListMasterData: Array<any> = [];

  //filters
  enrollmentStatus: Map<string, Array<string>> = new Map<string, Array<string>>([

    // [EnrollmentConstants.ENROLLED, [EnrollmentConstants.ENROLLED]],
    [EnrollmentConstants.ENROLLMENT_IN_PROGRESS, [EnrollmentConstants.ENROLLMENT_INITIATED, EnrollmentConstants.ENROLLMENT_IN_PROGRESS, EnrollmentConstants.ENROLLMENT_RETRY]],
    [EnrollmentConstants.ENROLLMENT_FAILED, [EnrollmentConstants.ENROLLMENT_FAILED, EnrollmentConstants.ENROLLMENT_CANCELED]],
    // [EnrollmentConstants.UNENROLLED, [EnrollmentConstants.UNENROLLED]],
    // [EnrollmentConstants.ENROLLMENT_RETRY, [EnrollmentConstants.ENROLLMENT_RETRY]],
    [EnrollmentConstants.UNENROLLMENT_IN_PROGRESS, [EnrollmentConstants.UNENROLLMENT_INITIATED, EnrollmentConstants.UNENROLLMENT_IN_PROGRESS, EnrollmentConstants.UNENROLLMENT_RETRY]],
    [EnrollmentConstants.UNENROLLMENT_FAILED, [EnrollmentConstants.UNENROLLMENT_FAILED, EnrollmentConstants.UNENROLLMENT_CANCELED]],
    // [EnrollmentConstants.UNENROLLMENT_RETRY, [EnrollmentConstants.UNENROLLMENT_RETRY]]
  ]);

  selectedEnrollmentStatus: any = null;
  selectedFromDate = new Date();
  selectedToDate = new Date();
  today = new Date();

  // Enrollment/Unenrollment State-message mapping
  enrollmentStates: Map<string, string> = new Map<string, string>([
    //ENROLLMENT
    ['KMR_GET_VEHICLE_SERVICES', 'Kamereon Get Vehicle Services'],
    ['KMR_PATCH_USAGE_MODE', 'Kamereon Patch Usage Mode'],
    ['NNA_OP_USER_ENROLLMENT', 'NNA OP User Enrollment'],
    ['NNA_OP_VEHICLE_ENROLLMENT', 'NNA OP Vehicle Enrollment'],
    ['KMR_ADD_USER', 'Kamereon Add User'],
    ['KMR_ADD_VEHICLE', 'Kamereon Add Vehicle'],
    //UNENROLLMENT
    ['MONITORING_DATA_CLEANUP', 'Monitoring Data Cleanup'],
    ['KMR_DATA_RESET', 'Kamereon Data Reset'],
    ['KMR_DATA_WIPE', 'Kamereon Data Wipe'],
    ['KMR_DELETE_VEHICLE', 'Kamereon Delete Vehicle'],
    ['KMR_DELETE_USER', 'Kamereon Delete User'],
    ['NNA_OP_DELETE_VEHICLE', 'NNA OP Delete Vehicle']
  ]);

  isEnrollmentStatus: boolean = true;
  searchVin: any;
  enrollmentErrors = [];
  defaultPeriod = 30;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toastService: ToastService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.account = this.utilService.selectedRentalFleetAccount;
    // this.init();
  }

  init() {
    // this.resetEnrollVehicles();
    this.initCalendarDates();
    this.getEnrollmentStatus();
  }

  initCalendarDates() {
    this.today = new Date();
    this.today.setHours(23);
    this.today.setMinutes(59);
    this.selectedFromDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()-this.defaultPeriod, 0, 0, 0, 0);
    this.selectedToDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 23, 59, 59, 999);
  }

  getEnrollmentStatusData() {
    var enrollmentStatuses = [EnrollmentConstants.UNENROLLMENT_IN_PROGRESS, EnrollmentConstants.UNENROLLMENT_FAILED, EnrollmentConstants.UNENROLLMENT_RETRY];

    if (this.selectedEnrollmentStatus && enrollmentStatuses.includes(this.selectedEnrollmentStatus)) {
      this.getUnenrollmentStatus();
    } else {
      this.getEnrollmentStatus();
    }
  }

  getUnenrollmentStatus() {
    var requestPayload = this.getRequestPayload();
    this.utilService.showSpinner();
    this.apiService.unenrollStatusData(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle response ::", data);
      this.sortAttemptsData(data);
      this.vehicleList = data;

      // if (this.vehicleList.length > 0) {
        this.isEnrollmentStatus = false;
      // }

      this.vehicleListMasterData = this.vehicleList.map(x => Object.assign({}, x));
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getUnenrollmentStatus();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getEnrollmentStatus() {

    var requestPayload = this.getRequestPayload();
    this.utilService.showSpinner();
    this.apiService.enrollStatusData(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle response ::", data);
      this.sortAttemptsData(data);
      this.vehicleList = data;

      // if (this.vehicleList.length > 0) {
        this.isEnrollmentStatus = true;
      // }

      this.vehicleListMasterData = this.vehicleList.map(x => Object.assign({}, x));
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getEnrollmentStatus();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  sortAttemptsData(data: any[]) {
    if (isNullOrUndefined(data) || data.length == 0) return;

    data.forEach(item => {
      var attempts = item.attempts;
      if (!isNullOrUndefined(attempts) && data.length > 0) {
        this.sortByDate("attemptedAt", attempts);
      }
    });
  }

  getRequestPayload() {
    var request = {
      "fromDate": isNullOrUndefined(this.selectedFromDate) ? null : this.datePipe.transform(this.selectedFromDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),//"2021-01-02T12:56:56.876Z",
      "toDate": isNullOrUndefined(this.selectedFromDate) ? null : this.datePipe.transform(this.selectedToDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),//"2021-08-02T12:56:56.876Z",
      "statusList": isNullOrUndefined(this.selectedEnrollmentStatus) ? ["ENROLLMENT_FAILED", "ENROLLMENT_CANCELED"] : this.enrollmentStatus.get(this.selectedEnrollmentStatus),
      // "vins": [
      //   "2N2AB7BV0LY139817"
      // ]
    };
    return request;
  }

  onEnrollmentStatusChange() {

  }

  onEnrollVehicles() {
    if (this.selectedVehicles.length == 0) {
      this.toastService.showWarning("Please select at least 1 vehicle");
      return;
    }
    var requestPayload = this.getSelectedVehicles();
    // console.log("selected vehicles: ", requestPayload);
    // return;
    this.utilService.showSpinner();
    this.apiService.enrollVehicles(requestPayload).then((data) => {
      this.toastService.showSuccess(MessageConstants.VEHICLE_ENROLLMENT_INITIATED);
      this.utilService.hideSpinner();
      console.log("vehicle enrollment response::", data);
      this.logEnrollmentErrors(data);
      this.resetEnrollVehicles();
      this.getEnrollmentStatus();
      this.saveEmitter.emit();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.onEnrollVehicles();
        });
      } else {
        this.utilService.hideSpinner();
        this.logEnrollmentErrors(error);
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getSelectedVehicles() {
    let vehicles = this.selectedVehicles.map((vehicle) => vehicle.vin);
    return {
      "vehicles": vehicles
    }
  }

  resetEnrollVehicles() {
    this.vehicleList = [];
    this.vehicleListMasterData = [];
    this.selectedVehicles = [];
    // this.resetCheckbox();

    this.selectedEnrollmentStatus = null;
    // this.selectedFromDate = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000);
    // this.selectedToDate = new Date();
    this.searchVin = null;
    this.initCalendarDates();
  }

  /* resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  } */

  isVehicleStatusSelected(vehicle: string): boolean {

    if (isNullOrUndefined(this.selectedVehicles) || this.selectedVehicles.length == 0) return false;
    return this.selectedVehicles.some(v => v.vin === vehicle);
  }

  onVehicleStatusSelectionChange(checked: boolean, vehicle: any) {

    var vehicleIndex = this.selectedVehicles.findIndex(v => v.vin === vehicle.vin);

    if (checked && vehicleIndex == -1) {
      this.selectedVehicles.push(vehicle);
    } else if (!checked && vehicleIndex >= 0) {
      this.selectedVehicles.splice(vehicleIndex, 1);
    }
  }

  sortByDate(fieldName: string, items) {
    items = items.sort(function (item1, item2) {
      // Recent First
      return <any>new Date(item2[fieldName]) - <any>new Date(item1[fieldName]);
    });
  }

  /**
   * Typeahead vin search
   *  */
  /* searchVehicle = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => (term === '' || term.length < 3) ? []
        : this.vehicleListMasterData.filter(vehicle => vehicle.vin.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    ) */
  searchVehicle = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => this.initVehicleList(term))
    )

  initVehicleList(term) {
    if (term === '') {
      this.vehicleList = this.vehicleListMasterData;
    } else if (term.length > 2) {
      return this.vehicleListMasterData.filter(vehicle => vehicle.vin.toLowerCase().indexOf(term.toLowerCase()) > -1);
    }
    return [];
  }

  formatter = (x: { vin: string }) => x.vin;

  onVehicleSelected(event) {
    event.preventDefault();
    // console.log("selected vehicle: ", event.item);
    this.vehicleList = [event.item];
  }

  // Typeahead vin search end

  getEnrollmentStateMessage(state: string) {
    if (!state) return null;
    return state.split('_').join(' ');
    // return state.replaceAll('_', ' '); // This function is not available

    // if (this.enrollmentStates.has(state)) {
    //   return this.enrollmentStates.get(state);
    // } else return state;
  }

  unenrollVehicles() {
    if (this.selectedVehicles.length == 0) {
      this.toastService.showWarning("Please select at least 1 vehicle");
      return;
    }
    var requestPayload = this.getSelectedVehicles();
    // console.log("selected vehicles: ", requestPayload);
    // return;
    this.utilService.showSpinner();
    this.apiService.unenrollVehicles(requestPayload).then((data) => {
      this.toastService.showSuccess(MessageConstants.VEHICLE_UNENROLLMENT_INITIATED);
      this.utilService.hideSpinner();
      console.log("vehicle unenrollment response::", data);
      this.logEnrollmentErrors(data);
      this.resetEnrollVehicles();
      this.getEnrollmentStatus();
      this.saveEmitter.emit();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.unenrollVehicles();
        });
      } else {
        this.utilService.hideSpinner();
        this.logEnrollmentErrors(error);
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateEnrollmentStatus() {
    this.enrollmentErrors = [];
    if (this.isEnrollmentStatus) {
      this.onEnrollVehicles();
    } else {
      this.unenrollVehicles();
    }
  }

  logEnrollmentErrors(enrollmentResponse) {
    let errors = enrollmentResponse.errorResponse;
    if (isNullOrUndefined(errors)) return;
    console.log("Enrollment Errors: " + errors);
    this.enrollmentErrors = errors;
    document.getElementById("openEnrollNowErrorsModal").click();
  }

}